
import { RouteConfig } from './types';
import LandingPage from '../pages/LandingPage';
import Login from '../pages/Login';
import Register from '../pages/Register';
import ForgotPassword from '../pages/ForgotPassword';
import Chat from '../pages/Chat';
import Pricing from '../pages/Pricing';
import About from '../pages/About';
import NotFound from '../pages/NotFound';

export const authRoutes: RouteConfig[] = [
  { path: "/", element: LandingPage, requiresLayout: false },
  { path: "/login", element: Login, requiresLayout: false },
  { path: "/register", element: Register, requiresLayout: false },
  { path: "/forgot-password", element: ForgotPassword, requiresLayout: false },
  { path: "/chat", element: Chat, requiresLayout: false },
  { path: "/pricing", element: Pricing, requiresLayout: false },
  { path: "/about", element: About, requiresLayout: false },
  { path: "*", element: NotFound, requiresLayout: false }
];
